import { CheckCircle2, FlaskConical, MinusCircle, PlugZap } from "lucide-react";

// Honest KATLAS evidence status.
const MAP = {
  live: { label: "Live receipt", cls: "bg-[#D1FAE5] text-[#065F46] border-[#A7F3D0]", Icon: CheckCircle2, dashed: false },
  verified_at_sign: { label: "Live receipt", cls: "bg-[#D1FAE5] text-[#065F46] border-[#A7F3D0]", Icon: CheckCircle2, dashed: false },
  simulated: { label: "Simulated (not live)", cls: "bg-[#DBEAFE] text-[#1E40AF] border-[#BFDBFE]", Icon: FlaskConical, dashed: false },
  unavailable: { label: "Node unavailable", cls: "bg-stone-100 text-stone-600 border-stone-300", Icon: MinusCircle, dashed: false },
  not_yet_connected: { label: "Not yet connected", cls: "bg-[#FEF3C7] text-[#B45309] border-[#FDE68A]", Icon: PlugZap, dashed: true },
};

export function StatusBadge({ status = "not_yet_connected", size = "sm" }) {
  const cfg = MAP[status] || MAP.not_yet_connected;
  const { Icon } = cfg;
  const pad = size === "lg" ? "px-3.5 py-1.5 text-sm" : "px-2.5 py-1 text-xs";
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 rounded-full border font-semibold ${cfg.dashed ? "border-dashed" : ""} ${cfg.cls} ${pad}`}
    >
      <Icon className="h-3.5 w-3.5" />
      {cfg.label}
    </span>
  );
}
